export const LOGO_URL = "https://customer-assets-v7afamib.emergentagent.net/job_235391e6-2bb3-445a-8a4e-0dadf4bf198d/artifacts/mcjuh6mz_ChatGPT%20Image%20Aug%2029%2C%202026%2C%2011_52_22%20AM.png";

export const CONTACT = {
  phone: "9100075778",
  whatsapp: "919100075778",
  email: "goodideainteriors@gmail.com",
  instagram: "good_idea_interiors",
  city: "Hyderabad",
  whatsappMsg: "Hello Good Idea Interiors! I'm interested in your interior design services in Hyderabad.",
};

export const CATEGORIES = [
  { id: "all", label: "All" },
  { id: "kitchen", label: "Modular Kitchen" },
  { id: "living", label: "Living Room" },
  { id: "bedroom", label: "Bedroom" },
  { id: "kids", label: "Kids Bedroom" },
  { id: "wardrobe", label: "Wardrobe" },
  { id: "dining", label: "Dining Room" },
  { id: "pooja", label: "Pooja Room" },
  { id: "bathroom", label: "Bathroom" },
  { id: "balcony", label: "Balcony" },
  { id: "1bhk", label: "1 BHK" },
  { id: "2bhk", label: "2 BHK" },
  { id: "3bhk", label: "3 BHK" },
];

export const TOP_CATEGORIES = [
  {
    id: "kitchen",
    label: "Modular Kitchen",
    image: "https://images.unsplash.com/photo-1682662044733-9120471befc7?w=400&q=80",
  },
  {
    id: "living",
    label: "Living Room",
    image: "https://images.pexels.com/photos/7148779/pexels-photo-7148779.jpeg?w=400",
  },
  {
    id: "bedroom",
    label: "Bedroom",
    image: "https://images.unsplash.com/photo-1771327811766-5f4149190b3d?w=400&q=80",
  },
  {
    id: "wardrobe",
    label: "Wardrobe",
    image: "https://images.unsplash.com/photo-1645237455598-e8f02d706a4e?w=400&q=80",
  },
  {
    id: "kids",
    label: "Kids Bedroom",
    image: "https://images.unsplash.com/photo-1600493505500-afac3fc363e6?w=400&q=80",
  },
  {
    id: "pooja",
    label: "Pooja Room",
    image: "https://images.unsplash.com/photo-1558442074-3c19857bc1dc?w=400&q=80",
  },
];

export const DESIGNS = [
  // Kitchens
  {
    id: 1,
    category: "kitchen",
    title: "Sleek Parallel Kitchen with Island Counter",
    image: "https://images.unsplash.com/photo-1682662044733-9120471befc7?w=600&q=80",
    tag: "Hyderabad",
  },
  {
    id: 2,
    category: "kitchen",
    title: "Modern L-Shaped Kitchen in Dual Tone",
    image: "https://images.unsplash.com/photo-1755771984341-546c2a04f236?w=600&q=80",
    tag: "Hyderabad",
  },
  {
    id: 3,
    category: "kitchen",
    title: "Premium U-Shaped Kitchen with Tall Units",
    image: "https://images.unsplash.com/photo-1684397671650-68fd1417fb3d?w=600&q=80",
    tag: "Hyderabad",
  },
  {
    id: 4,
    category: "kitchen",
    title: "Contemporary Black & White Modular Kitchen",
    image: "https://images.unsplash.com/photo-1682662045815-9016c6225dd3?w=600&q=80",
    tag: "Hyderabad",
  },
  // Living Rooms
  {
    id: 5,
    category: "living",
    title: "Grand Living Room with Layered Lighting",
    image: "https://images.pexels.com/photos/20418771/pexels-photo-20418771.jpeg?w=600",
    tag: "Hyderabad",
  },
  {
    id: 6,
    category: "living",
    title: "Contemporary Living Room with Pop Ceiling",
    image: "https://images.pexels.com/photos/7148779/pexels-photo-7148779.jpeg?w=600",
    tag: "Hyderabad",
  },
  {
    id: 7,
    category: "living",
    title: "Elegant Living Room with Marble Flooring",
    image: "https://images.unsplash.com/photo-1682662046426-f7589013d25e?w=600&q=80",
    tag: "Hyderabad",
  },
  {
    id: 8,
    category: "living",
    title: "Modern Open Living Room with TV Unit",
    image: "https://images.unsplash.com/photo-1682662046610-fbdb3db4bd74?w=600&q=80",
    tag: "Hyderabad",
  },
  // Bedrooms
  {
    id: 9,
    category: "bedroom",
    title: "Luxury Bedroom with Wooden Paneling",
    image: "https://images.unsplash.com/photo-1667375185194-57deec7e7a00?w=600&q=80",
    tag: "Hyderabad",
  },
  {
    id: 10,
    category: "bedroom",
    title: "Elegant Master Bedroom with Walk-in Wardrobe",
    image: "https://images.unsplash.com/photo-1645237455598-e8f02d706a4e?w=600&q=80",
    tag: "Hyderabad",
  },
  {
    id: 11,
    category: "bedroom",
    title: "Serene Bedroom with Pastel Tones",
    image: "https://images.unsplash.com/photo-1633605016186-a8a919b14f5d?w=600&q=80",
    tag: "Hyderabad",
  },
  {
    id: 12,
    category: "bedroom",
    title: "Modern Bedroom with Large Window & Wooden Accents",
    image: "https://images.unsplash.com/photo-1771327811766-5f4149190b3d?w=600&q=80",
    tag: "Hyderabad",
  },
  // Kids
  {
    id: 13,
    category: "kids",
    title: "Cozy Kids Bedroom with Study Corner",
    image: "https://images.unsplash.com/photo-1600493505500-afac3fc363e6?w=600&q=80",
    tag: "Hyderabad",
  },
  // Wardrobe
  {
    id: 14,
    category: "wardrobe",
    title: "Floor-to-Ceiling Sliding Wardrobe",
    image: "https://images.unsplash.com/photo-1558442074-3c19857bc1dc?w=600&q=80",
    tag: "Hyderabad",
  },
  // 2BHK
  {
    id: 15,
    category: "2bhk",
    title: "2 BHK Complete Interior – Modern Style",
    image: "https://images.unsplash.com/photo-1678762200388-51e11225d4de?w=600&q=80",
    tag: "Hyderabad",
  },
  // 3BHK
  {
    id: 16,
    category: "3bhk",
    title: "3 BHK Luxury Interior with Premium Finishes",
    image: "https://images.unsplash.com/photo-1600494448850-6013c64ba722?w=600&q=80",
    tag: "Hyderabad",
  },
];

export const STATS = [
  { number: "500+", label: "Happy Families in Hyderabad" },
  { number: "10+", label: "Years of Experience" },
  { number: "100%", label: "On-time Delivery" },
  { number: "5-Star", label: "Customer Rating" },
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Free Consultation",
    description: "Book a free consultation with our Hyderabad-based design experts. We understand your vision, budget, and lifestyle.",
    icon: "MessageSquare",
  },
  {
    step: "02",
    title: "3D Design & Planning",
    description: "Our designers create stunning 3D visualizations so you can see your dream home before construction begins.",
    icon: "Layers",
  },
  {
    step: "03",
    title: "Material Selection",
    description: "Choose from premium materials, finishes, and furniture curated for your taste and budget at our Hyderabad showroom.",
    icon: "Palette",
  },
  {
    step: "04",
    title: "Execution & Handover",
    description: "Our skilled team executes flawlessly with regular quality checks. Your dream home is delivered on time, every time.",
    icon: "CheckCircle",
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Priya Sharma",
    location: "Kondapur, Hyderabad",
    rating: 5,
    text: "Good Idea Interiors transformed our 3 BHK completely! The 3D designs helped us visualize everything perfectly. The modular kitchen is absolutely stunning and the team was professional throughout.",
    project: "3 BHK Complete Interior",
    avatar: "PS",
  },
  {
    id: 2,
    name: "Ravi Kumar",
    location: "Gachibowli, Hyderabad",
    rating: 5,
    text: "Best interior designers in Hyderabad! They completed our 2 BHK on time and within budget. The quality of work is exceptional. Our living room gets compliments from everyone who visits.",
    project: "2 BHK Living Room & Kitchen",
    avatar: "RK",
  },
  {
    id: 3,
    name: "Anitha Reddy",
    location: "Banjara Hills, Hyderabad",
    rating: 5,
    text: "I was amazed by their 3D visualization service. We could see exactly how our home would look before the work started. The execution matched the design perfectly. Highly recommended!",
    project: "Master Bedroom & Wardrobe",
    avatar: "AR",
  },
  {
    id: 4,
    name: "Suresh Naidu",
    location: "HITEC City, Hyderabad",
    rating: 5,
    text: "Professional team, beautiful designs, and excellent after-sales support. Good Idea Interiors understood our taste and delivered a home that reflects our personality perfectly.",
    project: "Complete Home Interior",
    avatar: "SN",
  },
];

export const WHY_CHOOSE_US = [
  {
    icon: "Cube",
    title: "3D Design Visualization",
    description: "See your dream home before it's built. Our advanced 3D visualizations ensure zero surprises.",
  },
  {
    icon: "Shield",
    title: "10-Year Warranty",
    description: "We stand behind our work with a comprehensive warranty on all furniture and installations.",
  },
  {
    icon: "Clock",
    title: "On-Time Delivery",
    description: "We respect your time. 100% of our Hyderabad projects are delivered on the promised date.",
  },
  {
    icon: "MapPin",
    title: "Hyderabad Specialists",
    description: "We understand Hyderabad's unique homes, climate, and lifestyle. Local expertise, global design.",
  },
  {
    icon: "IndianRupee",
    title: "Transparent Pricing",
    description: "No hidden costs. Get a detailed quote upfront. Budget-friendly options for every home.",
  },
  {
    icon: "Users",
    title: "Expert Design Team",
    description: "Our experienced designers bring your vision to life with creativity and precision.",
  },
];

export const BLOG_POSTS = [
  {
    id: 1,
    slug: "modular-kitchen-designs-hyderabad-2026",
    title: "Top 10 Modular Kitchen Designs for Hyderabad Homes in 2026",
    excerpt: "Discover the latest modular kitchen trends perfect for Hyderabad apartments. From L-shaped layouts to parallel kitchens, find your perfect style.",
    image: "https://images.unsplash.com/photo-1682662044733-9120471befc7?w=600&q=80",
    category: "Kitchen Design",
    date: "August 20, 2026",
    readTime: "6 min read",
    keywords: ["modular kitchen Hyderabad", "kitchen design 2026", "L-shaped kitchen"],
  },
  {
    id: 2,
    slug: "living-room-interior-design-hyderabad",
    title: "Living Room Interior Design Ideas for Hyderabad Apartments",
    excerpt: "Transform your Hyderabad living room with these stunning design ideas. Explore false ceilings, TV units, and furniture arrangements.",
    image: "https://images.pexels.com/photos/7148779/pexels-photo-7148779.jpeg?w=600",
    category: "Living Room",
    date: "August 15, 2026",
    readTime: "5 min read",
    keywords: ["living room design Hyderabad", "interior design", "TV unit design"],
  },
  {
    id: 3,
    slug: "3d-interior-design-hyderabad-benefits",
    title: "Why 3D Interior Design is a Game Changer for Hyderabad Homeowners",
    excerpt: "Learn how 3D visualization helps Hyderabad homeowners make confident decisions and avoid costly mistakes in their home interiors.",
    image: "https://images.unsplash.com/photo-1600494448850-6013c64ba722?w=600&q=80",
    category: "3D Design",
    date: "August 10, 2026",
    readTime: "7 min read",
    keywords: ["3D interior design Hyderabad", "interior visualization", "home design"],
  },
  {
    id: 4,
    slug: "bedroom-interior-design-ideas-hyderabad",
    title: "Bedroom Interior Design Ideas for Modern Hyderabad Homes",
    excerpt: "Create your perfect bedroom sanctuary with these expert tips on wardrobe placement, lighting, and color palettes for Hyderabad homes.",
    image: "https://images.unsplash.com/photo-1771327811766-5f4149190b3d?w=600&q=80",
    category: "Bedroom Design",
    date: "August 5, 2026",
    readTime: "5 min read",
    keywords: ["bedroom design Hyderabad", "wardrobe design", "master bedroom interior"],
  },
  {
    id: 5,
    slug: "2bhk-interior-design-cost-hyderabad",
    title: "2 BHK Interior Design Cost in Hyderabad – Complete Guide 2026",
    excerpt: "Everything you need to know about 2 BHK interior design costs in Hyderabad. Budget breakdown, tips to save money, and what to expect.",
    image: "https://images.unsplash.com/photo-1678762200388-51e11225d4de?w=600&q=80",
    category: "Cost Guide",
    date: "July 28, 2026",
    readTime: "8 min read",
    keywords: ["2 BHK interior cost Hyderabad", "interior design budget", "home renovation cost"],
  },
  {
    id: 6,
    slug: "pooja-room-designs-hyderabad",
    title: "Beautiful Pooja Room Designs for Hyderabad Homes – Traditional & Modern",
    excerpt: "Explore our collection of pooja room designs that blend traditional Indian aesthetics with modern interiors, perfect for Hyderabad homes.",
    image: "https://images.unsplash.com/photo-1558442074-3c19857bc1dc?w=600&q=80",
    category: "Pooja Room",
    date: "July 20, 2026",
    readTime: "4 min read",
    keywords: ["pooja room design Hyderabad", "mandir design", "pooja unit interior"],
  },
];

export const FAQS = [
  {
    q: "What is the cost of interior design in Hyderabad?",
    a: "Interior design costs in Hyderabad vary based on project scope. A 2 BHK typically starts from ₹3–5 lakhs for modular furniture and basic interiors. A complete 3 BHK with premium finishes may range from ₹8–15 lakhs. Contact us for a free, detailed quote tailored to your home.",
  },
  {
    q: "Do you provide 3D design visualizations before execution?",
    a: "Yes! We provide detailed 3D visualizations of every room before any work begins. This lets you see exactly how your home will look, make changes, and approve the final design with full confidence.",
  },
  {
    q: "How long does a home interior project take in Hyderabad?",
    a: "Typically, a 1 BHK takes 6–8 weeks, a 2 BHK takes 8–10 weeks, and a 3 BHK takes 10–14 weeks from design finalization to handover. We commit to timelines and deliver on time.",
  },
  {
    q: "Do you service all areas of Hyderabad?",
    a: "Yes, we serve all areas of Hyderabad including Gachibowli, HITEC City, Kondapur, Banjara Hills, Jubilee Hills, Madhapur, Kukatpally, Kompally, LB Nagar, and all other localities.",
  },
  {
    q: "What warranty do you provide on interior work?",
    a: "We provide a 10-year warranty on all modular furniture and a 1-year warranty on civil work and painting. Our post-installation support team is always available for any concerns.",
  },
  {
    q: "Do you handle the complete project or only design?",
    a: "We provide end-to-end interior design services — from design consultation and 3D visualization to material selection, execution, and final handover. You have a single point of contact throughout.",
  },
];
